import {
  ImportColumnConfig,
  ImportItemsConfig,
  spreadsheetBoolean,
  spreadsheetDate,
  spreadsheetNumber,
  spreadsheetString,
} from '@retail/products/components';
import { MarkupUploadDTO } from '@retail/markup/types';
import {
  recognizedCoverageDegreeHeadings,
  recognizedDiscountGroupHeadings,
  recognizedGroupNumberHeadings,
  recognizedGtinHeadings,
  recognizedIncMvaHeadings,
  recognizedMgItemNrHeadings,
  recognizedSalesFactorHeadings,
  recognizedSalesPriceHeadings,
  recognizedValidFromHeadings,
} from '@retail/utils';
import * as yup from 'yup';

export class MarkupConditionsImportConfig extends ImportItemsConfig<MarkupUploadDTO> {
  private constructor() {
    super();
  }

  static instance = new MarkupConditionsImportConfig();

  override columns: ImportColumnConfig<keyof MarkupUploadDTO>[] = [
    {
      name: 'mgItemNumber',
      recognizedColumnNames: ['MgItem-nummer', ...recognizedMgItemNrHeadings],
    },
    { name: 'gtinCode', recognizedColumnNames: ['GTIN', ...recognizedGtinHeadings] },
    {
      name: 'productGroupNumber',
      recognizedColumnNames: ['Varugrupp', ...recognizedGroupNumberHeadings],
    },
    {
      name: 'discountGroupCode',
      recognizedColumnNames: ['Rabattgrupp', ...recognizedDiscountGroupHeadings],
    },
    { name: 'validFrom', recognizedColumnNames: ['GyldigFra', ...recognizedValidFromHeadings] },
    {
      name: 'salesFactor',
      recognizedColumnNames: ['Salgsfaktor', ...recognizedSalesFactorHeadings],
    },
    { name: 'coverageDegree', recognizedColumnNames: ['TG', ...recognizedCoverageDegreeHeadings] },
    { name: 'salesPrice', recognizedColumnNames: ['Salgspris', ...recognizedSalesPriceHeadings] },
    { name: 'incMva', recognizedColumnNames: ['InkMva', ...recognizedIncMvaHeadings] },
  ];

  override schema = yup
    .object({
      mgItemNumber: spreadsheetNumber(),
      gtinCode: spreadsheetString(),
      productGroupNumber: spreadsheetString(),
      discountGroupCode: spreadsheetString(),
      validFrom: spreadsheetDate(),
      salesFactor: spreadsheetNumber(),
      coverageDegree: spreadsheetNumber(),
      salesPrice: spreadsheetNumber(),
      incMva: spreadsheetBoolean(),
    })
    .test(
      'one-markup-value',
      'Must provide exactly one markup value',
      (v) => [v?.salesPrice, v?.salesFactor, v?.coverageDegree].filter(Boolean).length === 1
    );

  override templateExampleData = {
    mgItemNumber: [300000000, 300000000, null],
    gtinCode: [null, '12345678901234', null],
    productGroupNumber: [null, null, '011'],
    discountGroupCode: [null, null, null],
    validFrom: ['2021-01-31', null, '2025-05-29'],
    salesFactor: [null, null, 1.87],
    coverageDegree: [20, null, null],
    salesPrice: [null, 199, null],
    incMva: [null, true, null],
  };
}
